import { GOAL_FULL_PAGE_SEARCH_PAGE, GOAL_FULL_PAGE_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const goalsAppGlobalSearchRoute: GlobalHomePageRoute = createGlobalRoute({
	layout: 'home',
	nav4Layout: 'expanded',
	exact: true,
	name: GOAL_FULL_PAGE_SEARCH_PAGE,
	path: GOAL_FULL_PAGE_SEARCH_PATH,
	query: ['text?'],
	subproduct: 'townsquare-goals',
});
